function findHighestCommonCharactersWithSingleString(arr, targetStr) {
  if (!Array.isArray(arr) || arr.length === 0 || typeof targetStr !== 'string') {
    return null; // Handle invalid inputs
  }

  // Tier 1: Check for an exact match
  for (const str of arr) {
    if (str === targetStr) {
      return str;
    }
  }

  // Tier 2: If no exact match, find the string with the most common unique characters
  let highestCount = 0;
  let result = null;

  const targetChars = new Set(targetStr);

  for (const str of arr) {
    let commonCount = 0;
    const commonChars = new Set();
    
    for (const char of str) {
      if (targetChars.has(char)) {
        commonChars.add(char);
      }
    }
    
    commonCount = commonChars.size;

    if (commonCount > highestCount) {
      highestCount = commonCount;
      result = str;
    }
  }

  return result;
}


export {
  findHighestCommonCharactersWithSingleString
};